<div class="compound-field">
  <div class="field">
    <label soho-label [for]="dimensionId">
      {{ 'Dimension' | translate }}
    </label>
    <select
      [id]="dimensionId"
      [name]="dimensionId"
      soho-dropdown noSearch
      [(ngModel)]="selectedDimension"
      (change)="dimensionChanged = true"
      >
      @for (item of dimensions; track trackByValueDimension($index, item)) {
        <option [ngValue]="item.value">{{item.label}}</option>
      }
    </select>
  </div>

  <div class="field">
    <label soho-label [for]="totalId">
      {{ 'Total' | translate }}
    </label>
    <select
      [id]="totalId"
      [name]="totalId"
      soho-dropdown noSearch
      [(ngModel)]="selectedTotal"
      (change)="totalChanged = true"
      >
      @for (item of totals; track trackByValueTotal($index, item)) {
        <option [ngValue]="item.value">{{item.label}}</option>
      }
    </select>
  </div>

  <div class="field">
    <label soho-label [for]="orderById">
      {{ 'OrderBy' | translate }}
    </label>
    <select
      [id]="orderById"
      [name]="orderById"
      soho-dropdown noSearch
      [(ngModel)]="selectedOrderBy"
      (change)="orderByChanged = true"
      >
      @for (item of orderBy; track trackByValueOrderBy($index, item)) {
        <option [ngValue]="item.value">{{item.label}}</option>
      }
    </select>
  </div>

  <div class="field">
    <input
      [id]="isAscendingId"
      type="checkbox"
      soho-checkbox
      [(ngModel)]="isAscending"
      (change)="isAscendingChanged = true"
      >
      <label soho-label [for]="isAscendingId" [forCheckBox]="true">
        {{ 'Ascending' | translate }}
      </label>
    </div>
  </div>